import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, baseimgUrl } from "../Univ";
import { Link } from "react-router-dom";
import "../MyStyles.css";

function Cart() {
  const [cart, setCart] = useState(null);
  const [customerPincode, setCustomerPincode] = useState(null);
  const [deliveryDays, setDeliveryDays] = useState(2); // base 2 days

  useEffect(() => {
    fetchCart();
    fetchUserPincode();
  }, []);

  // ------------------------
  // FETCH CART
  // ------------------------
  const fetchCart = async () => {
    const res = await axios.get(baseUrl + "cart/", );
    setCart(res.data);
  };
  const fetchUserPincode = async () => {
  const userId = localStorage.getItem("user_id");

  if (!userId) return;

  try {
    const res = await axios.get(baseUrl + `users/${userId}/`);
    setCustomerPincode(res.data.pincode);
  } catch (err) {
    console.error("Failed to fetch user pincode");
  }
};

const getDeliveryDays = (product) => {
  if (!product || !customerPincode) return 2;

  const sellerPin = product.seller?.pincode;
  if (!sellerPin) return 2;

  const diff = Math.abs(
    Number(sellerPin) - Number(customerPincode)
  );

  const extraDays = Math.floor(diff / 100);
  return 2 + extraDays;
};

  // ------------------------
  // UPDATE QTY
  // ------------------------
  const updateQty = async (item_id, qty) => {
    if (qty < 1) return; // min 1
    await axios.post(
      baseUrl + "update-cart/",
      { item_id, quantity: qty },
    );
    fetchCart();
  };

  // ------------------------
  // REMOVE ITEM
  // ------------------------
  const removeItem = async (item_id) => {
    await axios.post(
      baseUrl + "remove-cart/",
      { item_id },
      { headers: { Authorization: `Bearer ${localStorage.getItem("access")}` } }
    );
    fetchCart();
  };

  // ------------------------
  // PLACE ORDER
  // ------------------------
// ------------------------
// PLACE ORDER
// ------------------------
const placeOrder = async (paymentStatus) => {

  try {
    await axios.post(
      baseUrl + "place-order/",
      {
        payment_method: paymentStatus === "PAID" ? "ONLINE" : "COD",
        payment_status: paymentStatus,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`
        }
      }
    );

    alert("Order placed successfully!");
    fetchCart(); // clear cart UI

  } catch (err) {
    console.error(err);
    alert("Failed to place order");
  }
};

  // ------------------------
  // TOTAL
  // ------------------------
  const total =
    cart?.items?.reduce((sum, i) => sum + i.quantity * (i.product.discount_price || i.product.price), 0) || 0;

  if (!cart) return <h4>Loading...</h4>;

  return (
    <div className="container mt-4">
      <h3>Shopping Cart</h3>
      {cart.items.length === 0 ? (
        <h5>Your cart is empty</h5>
      ) : (
        <>
          {cart.items.map((item) => (
            <div key={item.id} className="cart-item row border p-3 mb-3 align-items-center">

              {/* IMAGE */}
              <div className="col-md-2">
                <Link
                    to={`/product/${item.id}`}
                    >
              <img
                      src={`${baseimgUrl}${item.product.images?.[0]?.image}`}  // Assuming your images are served via baseUrl
                      alt={item.product.name}
                      style={{ objectFit: "contain", maxHeight: "400px", width: "100%" }}
                    />
                    </Link>
              </div>

              {/* PRODUCT INFO */}
              <div className="col-md-5">
                <h6>{item.product.name}</h6>
                <p className="text-truncate" style={{ maxWidth: "100%" }}>
                  {item.product.description || "No description available."}
                </p>
                <p className="mb-2">
            <small className="text-success">
                FREE delivery in {getDeliveryDays(item.product)} day
                {getDeliveryDays(item.product) > 1 ? "s" : ""}

            </small>
          </p>
                <p className="text-success">In Stock</p>

              </div>

              {/* QUANTITY */}
              <div className="col-md-2 d-flex align-items-center">
                <button
                  onClick={() => updateQty(item.id, item.quantity - 1)}
                  className="btn btn-sm btn-secondary me-2"
                >
                  -
                </button>
                <span>{item.quantity}</span>
                <button
                  onClick={() => updateQty(item.id, item.quantity + 1)}
                  className="btn btn-sm btn-secondary ms-2"
                >
                  +
                </button>
              </div>

              {/* PRICE & REMOVE */}
              <div className="col-md-3">

                <div className="mb-2">
                <h4 className="text-success d-inline me-2">
                  ₹{(item.product.discount_price || item.product.price) * item.quantity}
                </h4>
                {item.product.discount_price && (
                  <span className="text-muted text-decoration-line-through">
                    ₹{item.product.price}
                  </span>
                )}
              </div>
                <button
                  onClick={() => removeItem(item.id)}
                  className="btn btn-sm btn-danger"
                >
                  Remove
                </button>
              </div>

            </div>
          ))}

          <hr />

          {/* SUBTOTAL */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Subtotal ({cart.items.length} item{cart.items.length > 1 ? "s" : ""}): ₹{total}</h4>
          <Link
  to="/checkout"
  state={{
    total: total,
    items: cart.items
  }}
  className="btn btn-success"
>
  Proceed to Buy
</Link>


          </div>
        </>
      )}
    </div>
  );
}

export default Cart;
